import SVRComment from './SVRComment';

export default SVRComment;
